import {IOrdersDetails} from '@app/checkout/models/order-details.model';
import {Order} from '@app/checkout/models/order-request.model';
import {IMyOrderRequestModel} from '@app/order/models/my-order-request.model';
import {EPdfDownloadStatus, IOrderResultsPdfState} from '@app/order/models/my-order-state.model';
import {IOrderStatus} from '@app/shared/models/orderStatus.model';
import {createAction, props} from '@ngrx/store';

export enum MyOrderActions {
  LoadListOfOrders = '[my-order component] my-oder page load list of orders',
  LoadListOfOrdersSuccess = '[my-order effect] my-oder load list of orders success',
  LoadListOfOrdersFailure = '[my-order effect] my-oder load list of orders Failure',
  LoadOrderStatus = '[my-order component] my-oder page load order status',
  LoadOrderStatusSuccess = '[my-order effect] my-oder load order status success',
  LoadOrderStatusFailure = '[my-order effect] my-oder load order status Failure',
  GetEditOrderDetails = '[order-details Component] Get edit order details',
  GetEditOrderDetailsSuccess = '[my-order effect] Get edit order details Success',
  GetEditOrderDetailsFailure = '[my-order effect] Get edit order details Failure',
  ResetEditOrderDetails = '[my-order Component] Reset edit order details',
  GetOrderResultsPdfDetails = '[order-details Component] Get order results details',
  GetOrderResultsPdfDetailsSuccess = '[my-order effect] Get order results Pdf details Success',
  GetOrderResultsPdfDetailsFailure = '[my-order effect] Get order results Pdf details Failure',
  ResetOrderResultsPdfDetails = '[order-details  Component] Reset order results Pdf details',
  DownloadOrderResults = 'order-details  Component] Download order results ',
  DownloadOrderResultsSuccess = '[my-order effect] Download order results Success',
  DownloadOrderResultsFailure = '[my-order effect] Download order results Failure',
  ResetDownloadOrderResultsStatus = '[my-order effect] Reset Download order results',
}

export const loadListOfOrders = createAction(MyOrderActions.LoadListOfOrders, props<{request: IMyOrderRequestModel}>());
export const loadListOfOrdersSuccess = createAction(
  MyOrderActions.LoadListOfOrdersSuccess,
  props<{orders: IOrdersDetails}>()
);
export const loadListOfOrdersFailure = createAction(MyOrderActions.LoadListOfOrdersFailure, props<{reason: string}>());

export const loadOrderStatus = createAction(MyOrderActions.LoadOrderStatus);
export const loadOrderStatusSuccess = createAction(
  MyOrderActions.LoadOrderStatusSuccess,
  props<{orderStatus: IOrderStatus[]}>()
);
export const loadOrderStatusFailure = createAction(MyOrderActions.LoadOrderStatusFailure, props<{reason: string}>());

export const getEditOrderDetails = createAction(MyOrderActions.GetEditOrderDetails, props<{orderId: string}>());

export const getEditOrderDetailsSuccess = createAction(
  MyOrderActions.GetEditOrderDetailsSuccess,
  props<{editOrderInfo: Order}>()
);

export const getEditOrderDetailsFailure = createAction(MyOrderActions.GetEditOrderDetailsFailure);

export const resetEditOrderDetails = createAction(MyOrderActions.ResetEditOrderDetails);

export const getOrderResultsPdfDetails = createAction(
  MyOrderActions.GetOrderResultsPdfDetails,
  props<{orderId: string}>()
);

export const getOrderResultsPdfDetailsSuccess = createAction(
  MyOrderActions.GetOrderResultsPdfDetailsSuccess,
  props<{resultsInfo: IOrderResultsPdfState[]}>()
);

export const getOrderResultsPdfDetailsFailure = createAction(MyOrderActions.GetOrderResultsPdfDetailsFailure);

export const resetOrderResultsPdfDetails = createAction(MyOrderActions.ResetOrderResultsPdfDetails);

export const downloadOrderResults = createAction(
  MyOrderActions.DownloadOrderResults,
  props<{orderId: string; name: string}>()
);

export const downloadOrderResultsSuccess = createAction(
  MyOrderActions.DownloadOrderResultsSuccess,
  props<{downloadStatus: EPdfDownloadStatus}>()
);

export const downloadOrderResultsFailure = createAction(MyOrderActions.DownloadOrderResultsFailure);

export const resetDownloadOrderResultsStatus = createAction(MyOrderActions.ResetDownloadOrderResultsStatus);
